var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlusLight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14.991,
    viewBox: "0 0 15 14.991",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_662",
    transform: "translate(-97.422 -148.42)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_546",
    d: "M564.382,167.483h-5.417c-.015,0-.029,0-.043,0h0a2.133,2.133,0,0,0-2.127,2.127v5.374a2.133,2.133,0,0,0,2.127,2.126h.087a2.046,2.046,0,0,0,2.04-2.04v-3.328H564.3a2.133,2.133,0,0,0,2.126-2.127v-.087A2.046,2.046,0,0,0,564.382,167.483Z",
    transform: "translate(-454 -13.694)",
    fill: "#62cbc9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_547",
    d: "M555.694,158.892h-.087a2.046,2.046,0,0,0-2.04,2.04v3.328h-3.246a2.133,2.133,0,0,0-2.127,2.127v.087a2.046,2.046,0,0,0,2.04,2.04h5.417c.014,0,.028,0,.043,0a2.133,2.133,0,0,0,2.127-2.127v-5.373A2.133,2.133,0,0,0,555.694,158.892Z",
    transform: "translate(-450.771 -10.472)",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_548",
    d: "M558.922,167.479a2.133,2.133,0,0,0-2.127,2.127v2.131h2.084c.014,0,.028,0,.043,0a2.133,2.133,0,0,0,2.127-2.127v-2.131h-2.084C558.95,167.483,558.936,167.479,558.922,167.479Z",
    transform: "translate(-454 -13.694)",
    fill: "#e5e1e6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusLight);
export default __webpack_public_path__ + "static/media/plus-light.36af6450.svg";
export { ForwardRef as ReactComponent };